export const environment = {
    production: true,
    // Relative: the backend is always served from /backend on the same host as the frontend
    apiUrl: '',
};



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/environments/environment.ts